import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { BoxV2 as Box } from 'portal-commons';
import RcsCampaigns from './RcsCampaigns';
import DraftRcsCampaigns from './DraftRcsCampaigns';
import { ListingTab } from '../components';
import { RcsCspListingTabConfig as ListingTabConfig } from '../constants';
import { RcsCspListingTabKey as ListingTabKey } from '../types';
import { DRAFT_RCS_CAMPAIGN_ENABLED } from '@/constants';

const RcsCampaignsContainer: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);
  const isDraft = searchParams.get('draft') === 'true';

  const handleTabChange = (tab: string) => {
    const tabLocation = ListingTabConfig.routes[tab as ListingTabKey];
    if (tabLocation) {
      const { pathname, search } = tabLocation;
      history.push({
        pathname,
        search: search || '',
      });
    }
  };

  return (
    <>
      {DRAFT_RCS_CAMPAIGN_ENABLED && (
        <Box
          sx={{ mt: -15, mb: 20, width: '100%' }}
          data-testid="rcsCampaignsListingTab"
        >
          <ListingTab
            items={ListingTabConfig.items}
            activeTab={isDraft ? 'draft-rcs-campaigns' : 'rcs-campaigns'}
            onTabChange={handleTabChange}
          />
        </Box>
      )}
      {isDraft ? <DraftRcsCampaigns /> : <RcsCampaigns />}
    </>
  );
};

export default RcsCampaignsContainer;
